"use client";

import * as React from "react";
import { motion } from "framer-motion";
interface StepItem {
  id: string;
  number: string;
  title: string;
  description: string;
}
const steps: StepItem[] = [{
  id: "step-1",
  number: "01",
  title: "01 — Tu me contactes",
  description: "Tu me racontes où tu en es et ce qui te ferait du bien."
}, {
  id: "step-2",
  number: "02",
  title: "02 — Nous choisissons ton rythme",
  description: "Nous définissons ensemble la durée, la fréquence et les dates selon mes disponibilités."
}, {
  id: "step-3",
  number: "03",
  title: "03 — Je viens chez toi",
  description: "Tu n'as rien à préparer. Nous adaptons chaque visite à tes besoins."
}];
export default function SimpleProcess() {
  return;
}